// Pure formatting helper shared by the live exam timer (ExamSession) and the
// public mock test runner. Kept as a standalone util — no hook needed, the
// timer drives re-renders by updating state every 100 ms.
export const formatExamTime = (seconds) => {
  const safe = Math.max(0, Math.floor(seconds || 0));
  const hrs = Math.floor(safe / 3600);
  const mins = Math.floor((safe % 3600) / 60);
  const secs = safe % 60;
  return [hrs, mins, secs]
    .map((v) => v.toString().padStart(2, "0"))
    .join(":");
};

export default formatExamTime;
